<template>
  <div class="v-dropdown-select__wrapper">
    <input
      type="text"
      :value="inputValue"
      :name="name"
      @input="onInput"
      @click="e => e.stopPropagation()"
    />
    <div class="select-ul__wrapper">
      <ul
        :class="{
          [classType]: true,
          ['extended']: filteredItems.length > 10
        }"
      >
        <li
          class="empty-tag"
          v-if="!filteredItems.length && inputValue === '' && !disableCreate"
        >
          Start typing in the input and create tag!
        </li>

        <li
          v-if="
            inputValue !== '' && !tagExists && !isTagChosen && !disableCreate
          "
          @click="addItem"
          class="new-item"
        >
          <span class="current-value"> {{ this.inputValue }} </span>
          <span class="add"> <i> Add new tag...</i></span>
        </li>

        <li
          v-for="item in filteredItems"
          v-if="filteredItems.length && !isSelected(item)"
          :key="item.key"
          :class="getItemClass(item.key)"
          @click="e => onSelect(e, item.key, item[valueField], item.label)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VInput from "@/components/VInput";

export default Vue.component("VDropDownSelect", {
  data() {
    return {
      inputValue: this.initialInput,
      localSelected: this.selectedItems
    };
  },

  props: {
    items: VueTypes.arrayOf(VueTypes.object).isRequired,
    valueField: VueTypes.string.def("value"),
    keyField: VueTypes.string.def("key"),
    labelField: VueTypes.string.def("label"),
    label: VueTypes.string,
    multiple: VueTypes.bool.def(false),
    name: VueTypes.string,
    onAddHandler: VueTypes.func,
    classType: VueTypes.oneOf(["primary", "secondary", "tertiary", "dark"]).def(
      "primary"
    ),
    selectedItems: VueTypes.arrayOf(VueTypes.string).def([]),
    errors: VueTypes.arrayOf(VueTypes.string).def([]),
    chosenTagNames: VueTypes.array,
    initialInput: VueTypes.string.def(""),

    // disable create new tag
    disableCreate: VueTypes.bool.def(false)
  },

  components: {
    VInput
  },

  methods: {
    onSelect(e, key, value, label) {
      e.stopPropagation();
      this.$emit("select", key, value, label);
    },

    isSelected(item) {
      return this.chosenTagNames.includes(item.label);
    },

    onInput(e) {
      this.inputValue = e.target.value;
    },

    getItemClass(key) {
      return this.localSelected.indexOf(key) !== -1 ? "active" : "";
    },

    addItem(e) {
      e.stopPropagation();

      const newTag = {
        label: this.inputValue,
        value: `#new-${this.inputValue}`,
        key: this.inputValue.trim().toLowerCase()
      };

      this.onAddHandler ? this.onAddHandler(newTag) : null;
      this.$emit("add", newTag);
      this.inputValue = "";
    }
  },

  computed: {
    filteredItems() {
      return this.items.filter(
        item =>
          item &&
          item.label.toLowerCase().indexOf(this.inputValue.toLowerCase()) !== -1
      );
    },

    tagExists() {
      return (
        this.filteredItems.length &&
        this.filteredItems.filter(item => item.label === this.inputValue)[0]
      );
    },

    isTagChosen() {
      return this.chosenTagNames.includes(this.inputValue);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-dropdown-select";

.#{$ns} {
  &__wrapper {
    width: 100%;

    input {
      width: 100%;
      padding: 4px 6px;
      color: $secondary-text-color;
      font-size: 14px;
      font-family: "Lato-Regular", Arial, sans-serif;
      height: 25px;
      display: flex;
      align-items: center;
      outline: none;
      box-shadow: 0 0 4px rgba(87, 87, 245, 0.14);
      border-radius: 2px;
      border: 1px solid #b6b6ff;
    }
  }
}

.select-ul__wrapper {
  max-height: 200px;
  overflow: auto;
  box-shadow: 0 2px 11px rgba(0, 0, 0, 0.14);
  margin-bottom: 11px;
  margin-top: 6px;
  border-radius: 4px;
}

ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  &.extended {
    justify-content: flex-start;
  }

  li {
    font-family: Roboto, Arial, sans-serif;
    cursor: pointer;
    display: block;
    width: 100%;
    height: $input-height;
    font-size: 14px;
    padding: 7px;

    &.new-item {
      display: flex;
      justify-content: space-between;
      color: #00adff;

      .current-value {
        @include textCropEllipsis();
        max-width: 75%;
      }

      .add {
        font-family: "Roboto-Light", sans-serif;
        font-style: italic;
      }
    }

    &.not-found {
      cursor: default;
      &:hover {
        background: white;
      }
    }
  }

  &.primary {
    li.active,
    li:hover {
      background-color: $primary-color;
      border-color: $primary-color;
      color: $white;
    }
  }

  & li.empty-tag {
    & {
      white-space: normal;
      height: 56px;
      padding: 10px;
      line-height: 1.5;
      overflow: hidden;
    }

    &,
    &:hover {
      display: flex;
      align-items: center;
      border: none;
      background-color: transparent;
      color: $button-dark-color;
      padding: 0 5px;
      cursor: default;
    }
  }
}
</style>
